export default "__VITE_ASSET__XCq$iuyG__"